import { z } from 'zod'
import { defineAction } from '~/prix'
import userPermissionCatalogAction from './generalUserPermissionCatalog.action.json' with { type: 'json' }

const userPermissionCatalogDefinition = defineAction({
  ...userPermissionCatalogAction,

  input: z.object({}),
  output: z.object({
    permissions: z.array(z.any()),
    accessAreas: z.array(z.any()),
    rolePermissionKeys: z.record(z.array(z.string())),
  }),
})

export default userPermissionCatalogDefinition
